import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import i18n from "./i18n";
const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const initial = (() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
    return saved && saved.toLowerCase().startsWith("en") ? "en" : "es";
  })();

  const [lang, setLang] = useState(initial);

useEffect(() => {
  localStorage.setItem("lang", lang);
  document.documentElement.setAttribute("lang", lang);

  // 🔥 sincroniza react-i18next
  i18n.changeLanguage(lang);
}, [lang]);


  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggleLang: () => setLang((prev) => (prev === "es" ? "en" : "es")),
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang debe usarse dentro de <LanguageProvider>");
  return ctx;
}
